// src/composables/api/ticketing/useTicketingEventsApi.ts
import { useAuthHttp } from '../useAuthHttp';
import type { AxiosRequestConfig } from 'axios';

type AnyResponse = any;

export function useTicketingEventsApi() {
  const { get, post, put, del, patch } = useAuthHttp();

  // POST /api/ticketing/events
  const createEvent = async (formData: object, config: AxiosRequestConfig = {}): Promise<AnyResponse> => {
    return await post('/ticketing/events', formData, config);
  };

  // GET /api/ticketing/events
  const listEvents = async (config: AxiosRequestConfig = {}): Promise<AnyResponse> => {
    return await get('/ticketing/events', config);
  };

  // GET /api/ticketing/events/:id
  const getEvent = async (eventId: string | number, config: AxiosRequestConfig = {}): Promise<AnyResponse> => {
    return await get(`/ticketing/events/${eventId}`, config);
  };

  // GET /api/ticketing/events/:id/dashboard
  const getEventDashboard = (eventId: string | number, config: AxiosRequestConfig = {}): Promise<AnyResponse> =>
    get(`/ticketing/events/${eventId}/dashboard`, config);  

  // PUT /api/ticketing/events/:id
  const updateEvent = async (
    eventId: string | number,
    formData: object,
    config: AxiosRequestConfig = {}
  ): Promise<AnyResponse> => {
    return await post(`/ticketing/events/${eventId}`, formData, config);
  };

  // DELETE /api/ticketing/events/:id
  const deleteEvent = async (eventId: string | number, config: AxiosRequestConfig = {}): Promise<AnyResponse> => {
    return await del(`/ticketing/events/${eventId}`, config);
  };

  const updateEventTax = (eventId: string | number, payload: object, config: AxiosRequestConfig = {}): Promise<AnyResponse> =>
    patch(`/ticketing/events/${eventId}/tax`, payload, config)

  const updateEventFees = (eventId: string | number, payload: object, config: AxiosRequestConfig = {}): Promise<AnyResponse> =>
    patch(`/ticketing/events/${eventId}/fees`, payload, config)

  const updateEventConfirmations = (eventId: string | number, payload: object, config: AxiosRequestConfig = {}): Promise<AnyResponse> =>
    patch(`/ticketing/events/${eventId}/confirmations`, payload, config)

  const updateEventDetails = (eventId: string | number, payload: object, config: AxiosRequestConfig = {}): Promise<AnyResponse> =>
    patch(`/ticketing/events/${eventId}/event-details`, payload, config)  

const updateEventMedia = (
    eventId: string | number,
    formData: FormData,
    config: AxiosRequestConfig = {}
  ) => post(`/ticketing/events/${eventId}/media`, formData, config);

  // GET /api/ticketing/events/:id/gallery
  const getGalleryImages = async (
    eventId: string | number,
    groupId?: number | null,
    config: AxiosRequestConfig = {}
  ): Promise<AnyResponse> => {
    const params = groupId !== undefined && groupId !== null ? { group_id: groupId } : {};
    return await get(`/ticketing/events/${eventId}/gallery`, { ...config, params });
  };

  // POST /api/ticketing/events/:id/gallery
  const updateGalleryImages = async (
    eventId: string | number,
    formData: FormData,
    config: AxiosRequestConfig = {}
  ): Promise<AnyResponse> => {
    return await post(`/ticketing/events/${eventId}/gallery`, formData, config);
  };

  return {
    createEvent,
    listEvents,
    getEvent,
    getEventDashboard,
    updateEvent,
    deleteEvent,
    updateEventTax,
    updateEventFees,
    updateEventConfirmations,
    updateEventMedia,
    updateEventDetails,
    getGalleryImages,
    updateGalleryImages
  };
}